import { useCallback, RefObject, FormEvent } from 'react';
import { MatchAdmin, MatchEventRecordingOption } from '../models/interfaces/Match';

interface Props {
    setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
    matchAdmin: MatchAdmin;
    formEl: RefObject<HTMLFormElement>;
    handleReset: (e?: FormEvent<HTMLFormElement> | undefined) => void;
}
export default function useMatchStatFormShortCuts({
    setFieldValue,
    matchAdmin,
    formEl,
    handleReset,
}: Props) {
    // handle keypress shortcut
    const handleKeyDown = useCallback(
        (e: KeyboardEvent) => {
            const charCode = e.key.length === 1 ? e.key.toLowerCase().charCodeAt(0) : undefined;
            if (formEl.current) {
                // checks that shift isn't held & that the current key isn't shift
                if (!e.shiftKey) {
                    switch (charCode) {
                        case 'l'.charCodeAt(0):
                            setFieldValue('selectedTeam', matchAdmin.match.lightCapTeam);
                            break;
                        case 'd'.charCodeAt(0):
                            setFieldValue('selectedTeam', matchAdmin.match.darkCapTeam);
                            break;
                        case 'p'.charCodeAt(0):
                            let selectedPlayer = formEl.current.elements.namedItem(
                                'selectedPlayer'
                            ) as HTMLElement;
                            selectedPlayer && selectedPlayer.focus();
                            break;
                        case 'm'.charCodeAt(0):
                            let selectedMin = formEl.current.elements.namedItem(
                                'selectedMinutes'
                            ) as HTMLInputElement;
                            e.preventDefault();
                            selectedMin && selectedMin.focus();
                            break;
                        case 's'.charCodeAt(0):
                            let selectedSec = formEl.current.elements.namedItem(
                                'selectedSeconds'
                            ) as HTMLInputElement;
                            e.preventDefault();
                            selectedSec && selectedSec.focus();
                            break;
                        case 'q'.charCodeAt(0):
                            let selectedPeriod = formEl.current.elements.namedItem(
                                'selectedPeriod'
                            ) as HTMLElement;
                            selectedPeriod && selectedPeriod.focus();
                            break;
                        case 'c'.charCodeAt(0):
                            handleReset();
                            break;
                        default:
                            break;
                    }
                } else {
                    if (charCode) {
                        const recordingOptions = matchAdmin.recordingOptionGroups.reduce(
                            (currentRecordingOptions, recordingGroup) => {
                                return currentRecordingOptions.concat(
                                    recordingGroup.recordingOptions
                                );
                            },
                            new Array<MatchEventRecordingOption>()
                        );
                        recordingOptions.forEach((option) => {
                            switch (charCode) {
                                case option.shortcutKey.charCodeAt(0):
                                    setFieldValue('selectedStat', option);
                                    break;
                                default:
                                    break;
                            }
                        });
                    }
                }
            }
        },
        [
            formEl,
            matchAdmin.match.darkCapTeam,
            matchAdmin.match.lightCapTeam,
            matchAdmin.recordingOptionGroups,
            setFieldValue,
            handleReset,
        ]
    );
    return { handleKeyDown };
}
